var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.384,
    height: 16.843,
    viewBox: "0 0 21.384 16.843",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43.835 -49.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.088,57.421A3.724,3.724,0,1,1,62.811,53.7,3.729,3.729,0,0,1,59.088,57.421Zm0-5.947A2.224,2.224,0,1,0,61.311,53.7,2.226,2.226,0,0,0,59.088,51.474Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.562,57.856a3.316,3.316,0,1,1,3.316-3.316A3.32,3.32,0,0,1,49.562,57.856Zm0-5.132a1.816,1.816,0,1,0,1.816,1.816A1.819,1.819,0,0,0,49.562,52.724Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.585,66.817a.75.75,0,0,1-.75-.75v-2.18a4.137,4.137,0,0,1,4.122-4.041h3.606a.75.75,0,0,1,0,1.5H47.957a2.65,2.65,0,0,0-2.622,2.541v2.18A.75.75,0,0,1,44.585,66.817Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.469,66.817a.75.75,0,0,1-.75-.75v-2.18A2.651,2.651,0,0,0,61.1,61.346H56.775a2.66,2.66,0,0,0-2.567,2.541v2.18a.75.75,0,0,1-1.5,0v-2.18a4.154,4.154,0,0,1,4.054-4.041H61.1a4.137,4.137,0,0,1,4.123,4.041v2.18A.75.75,0,0,1,64.469,66.817Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.6b805b5a25f822d35a63c85a6e35e661.svg";
export { ForwardRef as ReactComponent };